@if (showFestival()){
<div
  class="festival-decoration"
  [class.christmas]="isChristmas()"
  [class.autumn]="isAutumn()"
  [class.thanksgiving]="isThanksgiving()"
  [class.light-theme]="isLightTheme()"
  [class.dark-theme]="!isLightTheme()"
>
  <!-- Snowflakes -->
  @if (isChristmas()){
  <div class="snowflakes">
    <div class="snowflake" *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]">
      <div class="flake">❄</div>
    </div>
  </div>
  }
  @if (showFallingLeaves()){
  <div class="autumn-leaves" aria-hidden="true">
    @for (leaf of fallingMaples; track $index) {
      <span
        class="autumn-leaf"
        [style.--leaf-left]="leaf.left"
        [style.--leaf-size]="leaf.size"
        [style.--leaf-duration]="leaf.duration"
        [style.--leaf-delay]="leaf.delay"
        [style.--leaf-drift]="leaf.drift"
        [style.--leaf-spin]="leaf.spin"
        [style.background-image]="'url(' + leaf.src + ')'"
      ></span>
    }
  </div>
  }
</div>
}
